import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWR from 'swr';

export interface EthereumPendingQueueInfo {
  /**
   * 质押队列，单位为分钟
   */
  activeQueue: number;
  /**
   * 退出队列，单位为分钟
   */
  withdrawalQueue: number;
}
/**
 * useEthereumPendingQueueInfo
 */
export default function useEthereumPendingQueueInfo() {
  return useSWR(
    '/api/v2/eth2/pendingQueue/info',
    url => request.post<ResponseObject<EthereumPendingQueueInfo>>(url),
    {
      refreshInterval: 60_000,
      keepPreviousData: true,
    }
  );
}
